<script>
import Aws from '@/services/Aws';
import { required} from "vuelidate/lib/validators";
import validationMessages from '@/components/validations'

export default {
  components: {
    validationMessages,
  },
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      submitted: false,
      showModal: false,
      tryingToAdd: false,
      showLoader: false,
      modalTitle: "Add Parameter Store Value",
      Name: "",
      Value: "",
      Type: "String",
    };
  },
  validations() {
    return {
      Name: { required },
      Value: { required },
      Type: { required },
    };
  },
  methods: {

    closeModal() {
      this.showModal = false;
    },

    resetForm() {
      this.submitted = false;
      this.tryingToAdd = false;
      this.Name = "";
      this.Value = "";
      this.Type = "String";
      this.$v.$reset();
    },

    async addParameterStoreValue() {
      this.tryingToAdd = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToAdd = false;
        return;
      }

      try {
        const params = {
          Name: this.Name.trim(),
          Value: this.Value.trim(),
          Type: this.Type,
          csrf_token: this.csrf_token,
        };

        await Aws.addParameterStoreValue(params)
            .then((response) => {
              this.successmsg("Parameter successfully added to Parameter Store");
              this.closeModal();
            })
            .catch((error) => {
              const err =
                  error.response?.data?.error ||
                  error.message ||
                  "Failed to add parameter";
              this.failedmsg(err);
            })
            .finally(() => {
              this.refreshData?.();
              this.tryingToAdd = false;
            });
      } catch (error) {
        const err =
            error.response?.data?.error ||
            error.message ||
            "Unexpected error occurred";
        this.failedmsg(err);
        this.tryingToAdd = false;
      }
    },

    refreshData() {
      this.$emit('onRefresh')
    },

  },
};
</script>

<template>
  <b-modal v-model="showModal" id="addNewParameter" title="Add New Parameter Store Value" title-class="font-18" @hidden="resetForm" centered>
    <form @submit.prevent="addParameterStoreValue" v-if="!showLoader">
      <div class="row">
        <!-- Name -->
        <div class="col-sm-12">
          <label class="form-label mb-2">Name</label>
          <input
              type="text"
              v-model.trim="Name"
              class="form-control mb-2"
              :class="{ 'is-invalid': submitted && $v.Name.$error }"
              placeholder="/api/prod/params/tenant/key"
          />
          <validationMessages
              v-if="submitted"
              :fieldName="'Name'"
              :validationName="$v.Name"
          />
        </div>

        <!-- Value -->
        <div class="col-sm-12">
          <label class="form-label mb-2">Value</label>
          <input
              type="text"
              v-model.trim="Value"
              class="form-control mb-2"
              :class="{ 'is-invalid': submitted && $v.Value.$error }"
              placeholder="Enter value"
          />
          <validationMessages
              v-if="submitted"
              :fieldName="'Value'"
              :validationName="$v.Value"
          />
        </div>

        <!-- Type -->
        <div class="col-sm-12">
          <b-form-group label="Select Type" label-for="formrow-type-input">
            <select
                v-model="Type"
                class="form-select"
                :class="{ 'is-invalid': submitted && $v.Type.$error }"
            >
              <b-form-select-option :value="null">
                Please select type
              </b-form-select-option>
              <option value="String">String</option>
              <option value="StringList">StringList</option>
              <option value="SecureString">SecureString</option>
            </select>
            <validationMessages
                v-if="submitted"
                :fieldName="'Type'"
                :validationName="$v.Type"
            />
          </b-form-group>
        </div>
      </div>
    </form>

    <div class="card-body d-flex align-items-center justify-content-center" v-else>
      <b-spinner large></b-spinner>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="addParameterStoreValue" :disabled="tryingToAdd || showLoader">
        <b-spinner v-show="tryingToAdd" small></b-spinner>
        Add
      </b-button>
    </template>
  </b-modal>
</template>